ScrollClassDirective.$inject = [];
function ScrollClassDirective() {
    return {
        restrict: 'A',
        scope: {
            class: '@',
            target: '@'
        },
        link: function (scope, element, attrs) {
            var target = angular.element(document.querySelector('.' + scope.target));
            element.on('scroll', function (event) {
                if (element.scrollTop() > 10) {
                    target.addClass(scope.class);
                }
                else {
                    target.removeClass(scope.class);
                }
            });
        }
    };
}
angular.module('rinca.core.directives.scroll-class', [])
    .directive('scrollClass', ScrollClassDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/ScrollClassDirective.js
// module id = 312
// module chunks = 0